(function() {
	"use strict";

	angular.module("swurveys.maker")
		.controller("loginController", Handler);

	function Handler($scope, $routeParams, $timeout, $location, utilsService, loggedInUser, loadingBannerService, authService, signupModal, swurveysStageConfig) {

		var login = this;

		var credential = loggedInUser;

		login.message = $routeParams.message || "Sign-in with your email address or favorite social network";

		// If user is already logged in, redirect to dashboard
		if (credential.isLoggedIn()) {
			var uid = credential.swurveys.identityId();
			utilsService.gotoDashboard(uid);
		}

		var loginSuccess = function(err) {
			if (err) {
				if ($location.path() !== "/l")
					authService.relogin();
			}
			else {
				loadingBannerService.hide();

				login.identityId = credential.swurveys.identityId();

				if ($location.path() !== "/l")
					return;

				var pp = authService.getPreviousPath();

				var nextPath = (pp && pp !== "/l") ?
					pp : "/d/" + login.identityId;


				$timeout(function() {
					$location.path(nextPath).search({});
				});

			}
		};

		login.facebookAuth = function() {
			$scope.errorMessage = "";
			if (credential) {
				if(typeof FB === "undefined")
				{
					return $scope.errorMessage = "We are having problems loading login code from Facebook. Please try again later";
				}

                //We do this init here because Smooch tries to hijack the FB SDK from us.
				FB.init({
					appId: swurveysStageConfig.getConfigPropertyValue("facebook_app_id"),
					status: true,
					version: "v2.8"
				});
				FB.login(function(response) {
					if (!response.authResponse) {
						return console.log("ERR >>> ", response);
					}
					FB.api("/me", {
						fields: "name,email"
					}, function(data) {
						var userProfile = data;
						credential.saveUser(userProfile.name, userProfile.email, "facebook");

						loadingBannerService.show();
						authService.exchangeToken("graph.facebook.com",
							response.authResponse.accessToken,
							loginSuccess);

					});
				}, {
					scope: "public_profile,email"
				});
			}
		};

		login.googleAuth = function() {
			$scope.errorMessage = "";
			if(typeof credential.gAuth === "undefined")
			{
				return $scope.errorMessage = "We are having problems loading login code from Google. Please try again later";
			}

			if (credential) {
				credential.gAuth.signIn()
					.then(function(response) {
						var currentUser = credential.gAuth.currentUser.get();
						var userProfile = currentUser.getBasicProfile();
						var authResponse = currentUser.getAuthResponse();


						credential.saveUser(userProfile.getName(), userProfile.getEmail(), "google");

						loadingBannerService.show();
						authService.exchangeToken("accounts.google.com",
							authResponse.id_token,
							loginSuccess);

					});
			}
		};

		login.amazonAuth = function() {
			$scope.errorMessage = "";
			if(typeof amazon === "undefined")
			{
				return $scope.errorMessage = "We are having problems loading login code from Amazon. Please try again later";
			}
			if (credential) {
				amazon.Login.authorize({
					scope: "profile"
				}, function(response) {
					if (response.error) { // logged in
						console.log("ERR >>> ", response.error);
					}

					amazon.Login.retrieveProfile(response.access_token,
						function(data) {
							if (!data.success && data.error)
								return console.log(data.error);

							var userProfile = data.profile;


							credential.saveUser(userProfile.Name, userProfile.PrimaryEmail, "amazon");

							loadingBannerService.show();
							authService.exchangeToken("www.amazon.com",
								response.access_token,
								loginSuccess);

						});
				});
			}
		};

		login.cognitoAuth = function() {
			$scope.errorMessage = "";
			signupModal.show().then(function(modal) {
				modal.element.modal();
				modal.close.then(function(cognitoUser) {
					if (cognitoUser) {
						cognitoUser.getSession(function(err, result) {
							var jwt = result.getIdToken().getJwtToken();
							console.log(jwt);

							var name;
							var email;

							cognitoUser.getUserAttributes(function(err, result) {
								console.log(result);
								result.forEach(function(attr) {
									if (attr.Name == "name") {
										name = attr.Value;
									}
									if (attr.Name == "email") {
										email = attr.Value;
									}
								});
								credential.saveUser(name, email, "email");

								loadingBannerService.show();
								authService.exchangeToken("cognito-idp.us-east-1.amazonaws.com/" + swurveysStageConfig.getConfigPropertyValue("user_pool_id"),
									jwt,
									loginSuccess);
							});
						});
					}
				});
			});
		};
	}
}());
